import {
  ActiveCallPill,
  callStatusLabel,
  firstLine,
  PresencePill,
  toneForStatus,
} from '@relay-towing/ui';
import { useNavigate } from 'react-router-dom';
import { useActiveCalls } from '../../hooks/useActiveCalls';
import { useDriverProfile } from '../../hooks/useDriverProfile';
import { useHybridAuth } from '../../hooks/useHybridAuth';
import { useMember } from '../../hooks/useMember';
import { dutyLabel, dutyTone } from '../status';
import { useShell } from './ShellContext';

/**
 * On every tab: who you are and your duty status along the top, which opens
 * the menu, and the call you are on docked above the tab bar, which opens
 * it. On more than one call, the pill counts them and opens the list.
 */
export function ShellPills() {
  const { openMenu } = useShell();
  const navigate = useNavigate();
  const { user } = useHybridAuth();
  const { data: profile } = useDriverProfile();
  const member = useMember();
  const active = useActiveCalls();
  const first = active[0];

  // The profile's name is the one the office sees; the login's is the
  // fallback for an office member with no Driver row.
  const name = profile?.name?.trim() || user?.name || 'Me';

  return (
    <>
      <PresencePill
        name={name}
        status={member.drives ? dutyLabel(profile?.status) : 'Office'}
        statusTone={member.drives ? dutyTone(profile?.status) : 'neutral'}
        aria-haspopup="dialog"
        onClick={openMenu}
      />
      {first ? (
        <ActiveCallPill
          address={firstLine(first.pickupLocation)}
          status={callStatusLabel(first.status)}
          statusTone={toneForStatus(first.status)}
          since={first.startedAt ?? undefined}
          count={active.length}
          onClick={() =>
            navigate(active.length > 1 ? '/calls' : `/calls/${first.id}`)
          }
        />
      ) : null}
    </>
  );
}
